import { request } from '../../util'

const url = '/private/api/settings/file-module-permissions'

export default {
  list () {
    return request(url)
  }
}
